import { usePrevious } from 'affiny-core/hooks';
import React, { useEffect, useRef } from 'react';

interface IAnimatedCounter {
  value: number;
}

const INTERVAL_DURATION = 10;

const AnimatedCounter = ({ value }: IAnimatedCounter) => {
  const prevProps = usePrevious({ value });
  const scoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let interval = 0;

    if (prevProps?.value !== value && scoreRef.current) {
      let counter = 0;

      interval = setInterval(() => {
        if (scoreRef.current) {
          scoreRef.current.innerText = String(counter);
        }

        if (counter++ >= value) {
          clearInterval(interval);
        }
      }, INTERVAL_DURATION);
    }

    return () => clearInterval(interval);
  }, [value]);

  return <span ref={scoreRef}></span>;
};

export default AnimatedCounter;
